module.exports = __webpack_public_path__ + "prod/1.42.2/img/ningbo-government.31480ab4.png";